module.exports = __webpack_public_path__ + "static/media/8900_Bathroom.d56f6513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Bathroom.jpg
// module id = 569
// module chunks = 0